import React, { memo, useCallback, useState } from 'react'

import { Button, CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import AccessCodeForm from 'Pods/Shared/Waitlist/AccessCodeForm/AccessCodeForm'
import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import applyAccessCodeResult from 'Pods/ThreeDStudio/Shared/Utils/applyAccessCodeResult'

import UpgradeCard from '../UpgradeCard/UpgradeCard'

function WaitlistedBody({ onClose: handleClose }) {
  const [isCodeFormOpen, setIsCodeFormOpen] = useState(false)

  const handleToggleCodeForm = useCallback(() => {
    setIsCodeFormOpen(prev => !prev)
  }, [])

  return (
    <div className="usage-modal__waitlisted">
      <div className="usage-modal__waitlisted-headline">
        <Icon svgComponent={CircleCheck} color="positive" size={iconSizeMedium} notSpaced />
        <p className="cgt-heading-200">You&apos;re on the waitlist!</p>
      </div>
      <p className="usage-modal__waitlisted-copy cgt-body-md">
        We&apos;ll review your request and notify you by email once access is available.
      </p>

      <Button
        size="small"
        type="secondary"
        customClass="usage-modal__waitlisted-code-toggle"
        onClick={handleToggleCodeForm}
      >
        I have access code
      </Button>
      {isCodeFormOpen && <AccessCodeForm onApplied={applyAccessCodeResult} onClose={handleClose} />}

      <UpgradeCard onClose={handleClose} title="Faster access with Subscription" />
    </div>
  )
}

WaitlistedBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(WaitlistedBody)
